import React from 'react';
import { CalendarCheckIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { business, photos } from '../data/site';
export function Hero() {
  return <section id="top" className="relative w-full bg-ink text-white" data-id="element-113" data-mp="ehtk3yp8h5ov">
      <div className="absolute inset-0" data-id="element-114" data-mp="9ll64omrvija">
        <img src={photos.heroExterior} alt="Open service bays at East End Automotive Repair in Oak Ridge, Tennessee" className="h-full w-full object-cover object-[68%_center] opacity-50 lg:object-[60%_center]" data-id="element-115" data-mp="4lqiqv27hb2z" />
        <div className="absolute inset-0 bg-ink/75 lg:bg-ink/60" data-id="element-116" data-mp="xbpd95z660f1" />
      </div>

      <div className="relative mx-auto max-w-shell px-5 pb-16 pt-14 lg:px-8 lg:pb-24 lg:pt-20" data-id="element-117" data-mp="sai535t46z7u">
        <div className="max-w-[720px]" data-id="element-118" data-mp="nczsn5fw21v3">
          <p className="flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.18em] text-brand-light" data-id="element-119" data-mp="nbyhl0yvhfdd">
            <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-120" data-mp="3cz5u28857tyr" />
            Oak Ridge, Tennessee
          </p>

          <h1 className="mt-5 font-display text-[38px] font-extrabold leading-[1.03] tracking-[-0.02em] sm:text-[52px] lg:text-[64px]" data-id="element-121" data-mp="3j8iwsycd6eu6">
            Honest diagnosis.
            <br data-id="element-122" data-mp="3o6u7fbahgtdg" />
            Clear answers.
            <span className="block text-brand-light" data-id="element-123" data-mp="39al869qleg11">
              Specializing in professional results.
            </span>
          </h1>

          <p className="mt-6 max-w-[560px] text-[17px] leading-relaxed text-chalk/80 lg:text-lg" data-id="element-124" data-mp="3e84rvp627l0d">
            We find the actual cause, explain what we found in plain language,
            and give you the information to decide what happens next. That is
            the East End Automotive Way.
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-125" data-mp="2qlofuber9xlg">
            <a href={business.phoneHref} className="inline-flex items-center justify-center gap-3 whitespace-nowrap rounded-md bg-brand px-7 py-4 font-display text-lg font-bold tracking-tight text-white transition-colors duration-150 ease-out hover:bg-brand-light" data-id="element-126" data-mp="2vjq02znx42yi">
              <PhoneIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-127" data-mp="s3mcu1g2bwxu" />
              Call {business.phone}
            </a>
            <a href="#request" className="inline-flex items-center justify-center gap-2.5 rounded-md border border-white/25 px-7 py-4 text-base font-semibold text-white transition-colors duration-150 ease-out hover:border-white/60" data-id="element-128" data-mp="n9i4bdr5fgun">
              <CalendarCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-129" data-mp="1b0du65c1o1z9" />
              Request an Appointment
            </a>
          </div>

          <p className="mt-5 text-sm text-chalk/60" data-id="element-130" data-mp="112pz1eaj0sgk">
            Monday – Friday, 8:00 AM – 5:00 PM · {business.address.street},{' '}
            {business.address.city}, {business.address.state}
          </p>
        </div>
      </div>
    </section>;
}